module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [(_vm.mode === 'caregiver') ? _c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "yellow",
      "top": "",
      "right": "",
      "absolute": ""
    },
    on: {
      "click": function($event) {
        _vm.openAddDialog()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.userSurveys), function(userSurvey, index) {
    return [_c('v-list-tile', {
      key: userSurvey.id,
      class: {
        'red': userSurvey.id == _vm.selectedUserSurveyId, 'lighten-4': userSurvey.id == _vm.selectedUserSurveyId
      },
      attrs: {
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.selectUserSurvey(userSurvey.id)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "green darken-1"
      }
    }, [_vm._v(_vm._s(_vm.isComplete(userSurvey) ? 'check_circle' : 'more_horiz'))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.surveyName(userSurvey)))]), _vm._v(" "), (!_vm.isComplete(userSurvey)) ? _c('v-list-tile-sub-title', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("À compléter (" + _vm._s(_vm.answerCount(userSurvey)) + "/ " + _vm._s(_vm.questionCount(userSurvey)) + ")")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.userSurveyToDelete = _vm.clone(userSurvey);
          _vm.deleteDialog = true
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("delete")])], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.userSurveys.length) ? _c('v-divider', {
      key: userSurvey.id + '-'
    }) : _vm._e()]
  })], 2), _vm._v(" "), (_vm.userSurveys.length === 0) ? _c('v-card-text', {
    staticClass: "Aligner",
    staticStyle: {
      "height": "100px"
    }
  }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.addDialog),
      callback: function($$v) {
        _vm.addDialog = $$v
      },
      expression: "addDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Assigner des questionnaires")]), _vm._v(" "), _c('v-card-text', [_c('v-radio-group', {
    model: {
      value: (_vm.choice),
      callback: function($$v) {
        _vm.choice = $$v
      },
      expression: "choice"
    }
  }, _vm._l((_vm.surveys), function(survey, index) {
    return _c('div', [_c('v-radio', {
      key: index,
      attrs: {
        "label": survey.name,
        "value": survey
      }
    })], 1)
  }))], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.addDialog = false;
        _vm.assignSurveys()
      }
    }
  }, [_vm._v("Assigner")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.addDialog = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Confirmer")]), _vm._v(" "), _c('v-card-text', [_vm._v("Supprimer " + _vm._s(_vm.userSurveyToDelete.name) + " ?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false;
        _vm.deleteUserSurvey(_vm.userSurveyToDelete)
      }
    }
  }, [_vm._v("Supprimer")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1633b551","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/surveys/UserSurveyList.vue
// module id = 1173
// module chunks = 1